import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';

// TYPES
import { Types, AtualizarUsuario } from './types';

export const INITIAL_STATE: AtualizarUsuario = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): AtualizarUsuario {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_USUARIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_USUARIO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_USUARIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_USUARIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
